import React from "react";
import { DataTable, Table } from "@sscs/ui";
import { REPORT_PAGES_ROUTES, categoryToTitle } from "../../../constants";
import { filterByLink } from "../../../store/issuesSlice";
import { expandedRowsUpdated, focusedRowUpdated, selectExpandedRow, selectFocusedRow, } from "../../../store/policiesSlice";
import { ExpandedRowDetails } from "../../../ui";
import { LinkToReportTab, PolicyAudit, PolicyEnabled } from "../../common";
import { useReportDispatch, useReportSelector } from "../../hooks";
import styles from "./policy.module.scss";
const Policy = ({ policy }) => {
    var _a, _b, _c, _d;
    var _e;
    const dispatch = useReportDispatch();
    const isExpanded = useReportSelector((state) => selectExpandedRow(state, policy.id));
    const focusedRow = useReportSelector(selectFocusedRow);
    return (React.createElement(DataTable.ExpandedRow, { disabled: !((_a = policy.audit) === null || _a === void 0 ? void 0 : _a.present), expanded: isExpanded, focused: focusedRow === policy.id, onChange: (expanded) => dispatch(expandedRowsUpdated({
            id: policy.id,
            expand: expanded,
        })), onClick: () => dispatch(focusedRowUpdated(policy.id)) },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null,
                React.createElement(PolicyEnabled, { enabled: policy.enabled })),
            React.createElement(Table.Cell, null, ((_b = policy.count) === null || _b === void 0 ? void 0 : _b.violations) ? (React.createElement(LinkToReportTab, { id: policy.id, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE, color: "link", onClick: () => dispatch(filterByLink({
                    issue: { operation: "is", values: [policy.id] },
                })), className: styles["policy-id-link"] }, policy.id)) : (policy.id)),
            React.createElement(Table.Cell, null,
                policy.description,
                policy.assessment_label && (React.createElement("div", { className: styles["risk-assessment"] },
                    ((_c = policy.count) === null || _c === void 0 ? void 0 : _c.violations) ? "Causes risk" : "Could cause risk",
                    ":",
                    " ",
                    policy.assessment_label))),
            React.createElement(Table.Cell, null, policy.policy_category
                ? categoryToTitle[policy.policy_category]
                : ""),
            React.createElement(Table.Cell, null, (_e = (_d = policy.count) === null || _d === void 0 ? void 0 : _d.violations.toLocaleString()) !== null && _e !== void 0 ? _e : 0)),
        React.createElement(DataTable.ExpandedRow.Details, null, policy.audit && (React.createElement(ExpandedRowDetails, null,
            React.createElement(PolicyAudit, { audit: policy.audit }))))));
};
export default Policy;
//# sourceMappingURL=Policy.js.map